/* eslint-disable max-lines-per-function */
import { Button } from 'primereact/button'
import { Calendar } from 'primereact/calendar'
import { Dropdown } from 'primereact/dropdown'
import { Toolbar } from 'primereact/toolbar'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import ComboDropdownKhoaThi from '../../components/form/ComboDropdownKhoaThi'
import Table from '../../components/layout/Table'
import reportProcessor from '../../processor/reportProcessor'
import truongProcessor from '../../processor/truongProcessor'
import { dateToDDMMYY, DDMMYYToDate } from '../../utils/date'
import { exportExcel } from '../../utils/excel'

const date = new Date()
const y = date.getFullYear()
const m = date.getMonth()
const firstDay = new Date(y, m, 1)
const lastDay = new Date(y, m + 1, 0)
const firstDayStr = dateToDDMMYY(firstDay)
const lastDayStr = dateToDDMMYY(lastDay)
const mappingExport = {
  name: 'Trường',
  tongSo: 'Tổng số',
  daCapPhat: 'Đã cấp phát',
  chuaCapPhat: 'Chưa cấp phát',
}

export default function BanGiaoVanBangTongHop() {
  const khoaThiId = useSelector((item) => item.khoaThi.id)
  const [truongId, setTruongId] = useState(0)
  const [ngayBatDau, setNgayBatDau] = useState(firstDayStr)
  const [ngayKetThuc, setNgayKetThuc] = useState(lastDayStr)
  const [data, setData] = useState([])
  const [truongs, setTruongs] = useState([])

  useEffect(async () => {
    if (khoaThiId) {
      const rs = await reportProcessor.banGiaoVanBang({
        khoaThiId,
        truongId,
        ngayBatDau,
        ngayKetThuc,
      })
      setData(rs)
    }
  }, [khoaThiId, truongId, ngayBatDau, ngayKetThuc])
  useEffect(async () => {
    const rs = await truongProcessor.getAll()
    setTruongs([{ id: 0, name: 'Trường' }, ...rs])
  }, [])

  return (
    <>
      <div className="flex flex-column">
        <div className="flex justify-content-between">
          <h4>Báo cáo bàn giao văn bằng tổng hợp</h4>
          <div>
            <Button
              type="button"
              icon="pi pi-file-excel"
              className="p-button-success"
              onClick={() =>
                exportExcel(
                  data.map((item) => {
                    return {
                      ...item,
                    }
                  }),
                  'BanGiaoVanBangTongHop',
                  mappingExport,
                )
              }
              disabled={data.length === 0}
              label="Xuất excel"
            />
          </div>
        </div>
        <div className="card">
          <Toolbar
            className="mb-4"
            right={
              <div className="flex vanbang-seacher-cotainer">
                <div className="mr-2 mb-2 flex align-items-center">
                  <b className="mr-1">Từ ngày:</b>
                  <Calendar
                    showIcon
                    showButtonBar
                    dateFormat="dd/mm/yy"
                    placeholder="Từ ngày"
                    value={ngayBatDau ? DDMMYYToDate(ngayBatDau) : undefined}
                    onChange={(e) => {
                      if (e.value) {
                        setNgayBatDau(dateToDDMMYY(e.value))
                      } else {
                        setNgayBatDau(undefined)
                      }
                    }}
                  />
                </div>
                <div className="mr-2 mb-2 flex align-items-center">
                  <b className="mr-1">Đến ngày:</b>
                  <Calendar
                    showIcon
                    showButtonBar
                    dateFormat="dd/mm/yy"
                    placeholder="Đến ngày"
                    value={ngayKetThuc ? DDMMYYToDate(ngayKetThuc) : undefined}
                    onChange={(e) => {
                      if (e.value) {
                        setNgayKetThuc(dateToDDMMYY(e.value))
                      } else {
                        setNgayKetThuc(undefined)
                      }
                    }}
                  />
                </div>
                <div>
                  <Dropdown
                    // tooltip="Năm"
                    tooltipOptions={{ position: 'top' }}
                    className="mr-2 mb-2"
                    optionLabel="name"
                    optionValue="id"
                    options={truongs}
                    value={truongId}
                    onChange={(e) => {
                      setTruongId(e.value)
                    }}
                    filter
                    filterBy="name"
                  />
                </div>
                <ComboDropdownKhoaThi />
              </div>
            }
          />
          <Table
            data={data}
            column={[
              { value: 'name', name: 'Trường', sortable: true },
              { value: 'tongSo', name: 'Tổng số', sortable: true },
              { value: 'daCapPhat', name: 'Đã cấp phát', sortable: true },
              { value: 'chuaCapPhat', name: 'Chưa cấp phát', sortable: true },
            ]}
          />
        </div>
      </div>
    </>
  )
}
